import React, { useState, useContext } from "react";
import { Button } from "@chakra-ui/react";
import { useHistory } from 'react-router-dom';

import { IconLogout } from "@assets/Icons";
import { removeState } from "@lib/localStorage";
import { AuthContext } from '@contexts/AuthContext';
import * as actions from "@constants";
import { t } from "@lang/i18n";

const Logout = () => {
    const [loggedOut, setLoggedOut] = useState(false);

    const history = useHistory();
    const { dispatch } = useContext(AuthContext);

    const logging_out = () => {
        removeState("user-access-token")
        removeState("user-data")
        dispatch({ type: actions.LOGGED_OUT })
        history.push('/login')
    };


    if ( loggedOut ) logging_out();
   

    return(
        <Button leftIcon={<IconLogout />} variant="ghost" 
            textColor="white" fontWeight="400" mr="0rem"
            _hover={{bg: "invisible", border: "none"}}
            onClick={() => setLoggedOut(true)}>
            { t('nav_bar.logout') }
        </Button>
    )
}

export default Logout;